/** 
 Copyright Highway9 Networks Inc. 
 */ 
import { ErrorsComponent } from "@h9/ui-lib";
import { useState } from "react";

type Error = { message: string };

type UseErrorsAndWarningsReturn = {
  errors: Error[];
  warnings: Error[];
  setErrorsAndWarnings: (errorsData?: Error[], warningsData?: Error[]) => void;
  closeAll: () => void;
  closeAlert: (index: number, source: "error" | "warning") => void;
  ErrorsComponent: typeof ErrorsComponent;
};

const useErrorsAndWarnings = (): UseErrorsAndWarningsReturn => {
  const [errors, setErrors] = useState<Error[]>([]);
  const [warnings, setWarnings] = useState<Error[]>([]);

  const closeAlert = (index: number, source: "error" | "warning"): void => {
    if (source === "error") {
      const newErrorsArray = errors.filter((item, key) => key !== index);
      setErrors(newErrorsArray);
    } else if (source === "warning") {
      const newWarningsArray = warnings.filter((item, key) => key !== index);
      setWarnings(newWarningsArray);
    }
  };

  const closeAll = (): void => {
    setErrors([]);
    setWarnings([]);
  };

  const setErrorsAndWarnings = (errorsData: Error[] = [], warningsData: Error[] = []): void => {
    setErrors(errorsData);
    setWarnings(warningsData);
  };

  return { errors, warnings, setErrorsAndWarnings, closeAll, closeAlert, ErrorsComponent: ErrorsComponent };
};

export default useErrorsAndWarnings;

